import React, { useState } from 'react';

const QuizPage = ({ onQuizComplete }) => {
  // Questions et options du quiz
  const questions = [
    {
      id: 1,
      text: "Ta façon d’éduquer tes enfants ?",
      options: [
        { id: 'a', text: "Je privilégie la liberté et l’autonomie", points: 4 },
        { id: 'b', text: "Je veille constamment à leur sécurité et leur bien-être", points: 3 },
        { id: 'c', text: "Je leur donne beaucoup d'amour et de tendresse au quotidien", points: 2 },
        { id: 'd', text: "Je les pousse à se dépasser et à atteindre leurs objectifs", points: 1 }
      ]
    },
    {
      id: 2,
      text: "Face à un conflit avec ton enfant, tu réagis comment ?",
      options: [
        { id: 'a', text: "Je laisse passer, ils doivent apprendre par eux-mêmes", points: 4 },
        { id: 'b', text: "Je protège et calme la situation immédiatement", points: 3 },
        { id: 'c', text: "Je prends le temps de parler et de rassurer", points: 2 },
        { id: 'd', text: "Je pose des règles claires et insiste sur la discipline", points: 1 }
      ]
    },
    {
      id: 3,
      text: "Quel est ton style de vie avec tes enfants ?",
      options: [
        { id: 'a', text: "Spontané, on suit nos envies du moment", points: 4 },
        { id: 'b', text: "Prudent, je planifie tout pour éviter les risques", points: 3 },
        { id: 'c', text: "Chaleureux, on partage beaucoup de moments câlins", points: 2 },
        { id: 'd', text: "Ambitieux, je combine travail et éducation exigeante", points: 1 }
      ]
    },
    {
      id: 4,
      text: "Comment gères-tu le temps d'écran ?",
      options: [
        { id: 'a', text: "Je ne limite pas trop, ils apprennent aussi par là", points: 4 },
        { id: 'b', text: "Je contrôle strictement ce qu'ils regardent", points: 3 },
        { id: 'c', text: "Je privilégie les moments sans écran, pour plus de proximité", points: 2 },
        { id: 'd', text: "Je fixe des règles claires et des horaires précis", points: 1 }
      ]
    },
    {
      id: 5,
      text: "Quel est ton plus grand souhait pour tes enfants ?",
      options: [
        { id: 'a', text: "Qu'ils soient libres et heureux d'être eux-mêmes", points: 4 },
        { id: 'b', text: "Qu'ils soient protégés et en sécurité", points: 3 },
        { id: 'c', text: "Qu'ils grandissent dans un environnement rempli d'amour", points: 2 },
        { id: 'd', text: "Qu'ils réussissent et deviennent indépendants", points: 1 }
      ]
    },
    {
      id: 6,
      text: "Comment organises-tu les sorties en famille ?",
      options: [
        { id: 'a', text: "On improvise souvent, sans programme fixe", points: 4 },
        { id: 'b', text: "Je choisis des lieux sûrs et adaptés", points: 3 },
        { id: 'c', text: "Je privilégie les moments doux, comme les parcs ou la maison", points: 2 },
        { id: 'd', text: "Je planifie des activités enrichissantes et formatrices", points: 1 }
      ]
    },
    {
      id: 7,
      text: "Quelle est ta plus grande force en tant que papa ?",
      options: [
        { id: 'a', text: "Ma liberté d'esprit et ma flexibilité", points: 4 },
        { id: 'b', text: "Ma vigilance et mon sens de la protection", points: 3 },
        { id: 'c', text: "Mon empathie et ma douceur", points: 2 },
        { id: 'd', text: "Ma détermination et mon sens du devoir", points: 1 }
      ]
    },
    {
      id: 8,
      text: "Comment réagis-tu quand ton enfant fait une erreur ?",
      options: [
        { id: 'a', text: "Je le laisse apprendre sans trop intervenir", points: 4 },
        { id: 'b', text: "Je veille à ce qu'il ne se mette pas en danger", points: 3 },
        { id: 'c', text: "Je le console et l'encourage avec amour", points: 2 },
        { id: 'd', text: "Je lui explique l'importance de se relever et d'essayer encore", points: 1 }
      ]
    },
    {
      id: 9,
      text: "Quelle est ta devise de papa ?",
      options: [
        { id: 'a', text: "\"Laisse-les voler de leurs propres ailes.\"", points: 4 },
        { id: 'b', text: "\"Mieux vaut prévenir que guérir.\"", points: 3 },
        { id: 'c', text: "\"L'amour est la clé de tout.\"", points: 2 },
        { id: 'd', text: "\"Rien ne s'obtient sans effort.\"", points: 1 }
      ]
    },
    {
      id: 10,
      text: "Comment gères-tu ton équilibre personnel ?",
      options: [
        { id: 'a', text: "Je privilégie ma liberté et mon bien-être pour mieux les accompagner", points: 4 },
        { id: 'b', text: "Je mets leur sécurité avant tout, quitte à me sacrifier", points: 3 },
        { id: 'c', text: "Je prends soin de moi en cultivant l'amour familial", points: 2 },
        { id: 'd', text: "Je travaille dur pour leur offrir le meilleur avenir", points: 1 }
      ]
    }
  ];
  

  // État pour suivre les réponses sélectionnées
  const [answers, setAnswers] = useState({});
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showInstructions, setShowInstructions] = useState(true);

  // Gérer le changement de réponse
  const handleAnswerChange = (questionId, option) => {
    setAnswers({
      ...answers,
      [questionId]: option
    });
  };

  // Passer à la question suivante
  const handleNext = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      // Calculer le score total
      let totalScore = 0;
      Object.values(answers).forEach(answer => {
        totalScore += answer.points;
      });
      
      // Déterminer le type de maman
      let mamaType = '';
      if (totalScore >= 30 && totalScore <= 40) {
        mamaType = 'Le Papa Cool';
      } else if (totalScore >= 21 && totalScore <= 29) {
        mamaType = 'Le Papa Mature';
      } else if (totalScore >= 14 && totalScore <= 20) {
        mamaType = 'Le Papa Câlin';
      } else if (totalScore >= 10 && totalScore <= 13) {
        mamaType = 'Le Papa Vieille École';
      }
      
      // Passer les résultats au composant parent
      onQuizComplete({
        totalScore,
        mamaType,
        answers
      });
    }
  };

  // Passer à la question précédente
  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  // Commencer le quiz
  const startQuiz = () => {
    setShowInstructions(false);
  };

  // Afficher les instructions
  if (showInstructions) {
    return (
    <div>
      <h1 className="title-main">Spécial Fête des pères</h1>
      <h3 className="title-sub">Quel type de papa es-tu ?</h3>
      <br />
      <div className="container">
        <div className="header">
          <div className="instructions">
            <p>Réponds aux questions en choisissant la réponse qui te correspond le mieux. Additionne tes points pour découvrir ton profil de papa !</p>
          </div>
        </div>
        <button className="btn" onClick={startQuiz}>Commencer le test</button>
      </div>
    </div>
      
    );
  }

  // Récupérer la question actuelle
  const question = questions[currentQuestion];

  return (
    <div>
      <h1 className="title-main">Spécial Fête des pères</h1>
      <h3 className="title-sub">Quel type de papa es-tu ?</h3>
      <br />
      <div className="container">
        <div className="header">
          <div className="progress">
            Question {currentQuestion + 1} sur {questions.length}
          </div>
        </div>
        <div className="question-container">
          <div className="question">
            {question.text}
          </div>
          <div className="options">
            {question.options.map((option) => (
              <div 
                key={option.id} 
                className={`option ${!!answers[question.id] && answers[question.id].id === option.id ? 'selected' : ''}`}
                onClick={() => handleAnswerChange(question.id, option)}
              >
                <input 
                  type="radio" 
                  id={`question-${question.id}-option-${option.id}`}
                  name={`question-${question.id}`}
                  checked={!!answers[question.id] && answers[question.id].id === option.id}
                  onChange={() => handleAnswerChange(question.id, option)}
                />
                <label htmlFor={`question-${question.id}-option-${option.id}`}>{option.text}</label>
              </div>
            ))}
          </div>
        </div>
        <div className="navigation">
          {currentQuestion > 0 && (
            <button className="btn" onClick={handlePrevious}>Précédent</button>
          )}
          <button 
            className="btn" 
            onClick={handleNext}
            disabled={!answers[question.id] || answers[question.id] === undefined}
          >
            {currentQuestion === questions.length - 1 ? 'Voir les résultats' : 'Suivant'}
          </button>
        </div>
      </div>
    </div>
    
  );
};

export default QuizPage;
